//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const value = ref('Hello!')

    return { value }
  },
}
